export type UnitData = {
  formationRole: "front" | "middle" | "rear" | "excluded";
  enabled?: number;
  aircraft?: {
    role: "bomber" | "recon";
    magazine: number;
    rearm: number;
    transition: number;
  };
  name: string;
  cost: number;
  // Population slots the unit takes; 1 when omitted.
  pop?: number;
  time: number;
  hp: number;
  speed: number;
  armor: string;
  sight: number;
  requires: string[];
  weapon?: string;
  infantry?: boolean;
  airborne?: boolean;
  manualAttack?: boolean;
  limit?: number;
  transport?: { capacity: number; range: number };
  canBuild?: boolean;
  deploy?: {
    time: number;
    damage: number;
    range: number;
    requiresDeployment?: boolean;
  };
  captures?: boolean;
  voice?: string;
  gathers?: { capacity: number; load: number };
};

export const units: Record<string, UnitData> = {
  hoverBattery: {
    formationRole: "rear",
    enabled: 1,
    name: "Hover battery",
    cost: 700,
    pop: 2,
    time: 16,
    hp: 455,
    speed: 130,
    armor: "light",
    sight: 600,
    requires: [],
    voice: "vehicle",
    weapon: "hoverRockets",
  },

  petrel: {
    formationRole: "excluded",
    manualAttack: true,
    enabled: 1,
    name: "Strike bomber",
    aircraft: { role: "bomber", magazine: 3, rearm: 12, transition: 2 },
    cost: 1200,
    pop: 3,
    time: 25,
    hp: 585,
    speed: 220,
    armor: "light",
    sight: 600,
    requires: ["radar"],
    airborne: true,
    weapon: "bomb",
    voice: "vehicle",
  },
  reconDrone: {
    formationRole: "excluded",
    enabled: 1,
    name: "Recon drone",
    aircraft: { role: "recon", magazine: 1, rearm: 15, transition: 1 },
    cost: 300,
    time: 6,
    hp: 100,
    speed: 260,
    armor: "light",
    sight: 500,
    requires: [],
    airborne: true,
    manualAttack: true,
    voice: "vehicle",
  },
  strikeDrone: {
    formationRole: "excluded",
    enabled: 1,
    name: "Attack drone",
    cost: 450,
    pop: 2,
    time: 12,
    hp: 156,
    speed: 300,
    armor: "light",
    sight: 400,
    requires: [],
    airborne: true,
    manualAttack: true,
    weapon: "dronePayload",
    voice: "vehicle",
  },

  bombard: {
    formationRole: "rear",
    enabled: 1,
    name: "Bombard walker",
    cost: 900,
    pop: 2,
    time: 20,
    hp: 520,
    speed: 60,
    armor: "light",
    sight: 600,
    requires: ["radar"],
    weapon: "bombard",
    voice: "vehicle",
    deploy: { time: 2, damage: 1, range: 0, requiresDeployment: true },
  },
  engineer: {
    formationRole: "rear",
    enabled: 1,
    name: "Engineer",
    cost: 500,
    time: 10,
    hp: 70,
    speed: 60,
    armor: "infantry",
    infantry: true,
    sight: 600,
    requires: [],
    voice: "infantry",
    captures: true,
  },
  builder: {
    formationRole: "rear",
    enabled: 1,
    name: "Builder vehicle",
    cost: 1000,
    time: 15,
    hp: 300,
    speed: 90,
    sight: 600,
    armor: "light",
    requires: [],
    canBuild: true,
    voice: "builder",
  },
  hauler: {
    formationRole: "rear",
    enabled: 1,
    name: "Supply truck",
    cost: 600,
    time: 12,
    hp: 220,
    speed: 110,
    sight: 600,
    armor: "light",
    requires: [],
    voice: "hauler",
    gathers: { capacity: 300, load: 2 },
  },
  rifleman: {
    formationRole: "middle",
    enabled: 1,
    name: "Rifle infantry",
    cost: 150,
    time: 6,
    hp: 156,
    speed: 60,
    sight: 600,
    armor: "infantry",
    infantry: true,
    requires: [],
    weapon: "rifle",
    voice: "infantry",
  },
  rocketeer: {
    formationRole: "rear",
    enabled: 1,
    name: "Rocket infantry",
    cost: 300,
    time: 8,
    hp: 117,
    speed: 55,
    sight: 600,
    armor: "infantry",
    infantry: true,
    requires: [],
    weapon: "launcher",
    voice: "infantry",
  },
  grenadier: {
    formationRole: "rear",
    enabled: 1,
    name: "Grenadier",
    cost: 300,
    time: 8,
    hp: 169,
    speed: 55,
    sight: 600,
    armor: "infantry",
    infantry: true,
    requires: [],
    weapon: "grenade",
    voice: "infantry",
  },
  strider: {
    formationRole: "front",
    enabled: 1,
    name: "Strider",
    cost: 1000,
    pop: 3,
    time: 20,
    hp: 800,
    speed: 70,
    sight: 600,
    armor: "heavy",
    requires: [],
    weapon: "heavyCannon",
    voice: "vehicle",
  },
  buggy: {
    formationRole: "middle",
    enabled: 1,
    name: "Raider buggy",
    cost: 450,
    time: 9,
    hp: 300,
    speed: 160,
    sight: 600,
    armor: "light",
    requires: [],
    weapon: "machineGun",
    voice: "vehicle",
  },
};
